var data = {
  "body": "<g fill=\"none\"><path fill=\"#ED2939\" d=\"M.5.5h300v200H.5z\"/><path fill=\"#FFF\" d=\"M.5.5h200v200H.5z\"/><path fill=\"#002395\" d=\"M.5.5h100v200H.5z\"/></g>",
  "width": 301,
  "height": 201
};
exports.__esModule = true;
exports.default = data;